var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.958 47.427H8.469C3.792 47.427 0 43.635 0 38.958V8.46899C0 3.79199 3.792 0 8.469 0H38.958C43.635 0 47.427 3.79199 47.427 8.46899V38.958C47.427 43.636 43.636 47.427 38.958 47.427Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7229 37H25.9583V23.8898H29.6109L30 19.5001H25.9574C25.9574 19.5001 25.9574 17.8612 25.9574 16.9996C25.9574 15.9647 26.1651 15.5557 27.1664 15.5557C27.9719 15.5557 30 15.5557 30 15.5557V11C30 11 27.0122 11 26.3746 11C22.4789 11 20.722 12.716 20.722 16.0001C20.722 18.8607 20.722 19.5001 20.722 19.5001H18V23.9451H20.7238L20.7229 37Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDark);
export default __webpack_public_path__ + "static/media/facebook-dark.321a2918549ebe184c15277827605a01.svg";
export { ForwardRef as ReactComponent };